export const getPublicUrl = () => {
    const fromEnv = import.meta.env.VITE_PUBLIC_SITE_URL;
    if (fromEnv) {
        return fromEnv;
    }
    return window.location.origin;
};
